function OpenAdModal() {
  $("#myModal").modal("show");
}

if ($("#myModal")) {
  OpenAdModal();
}
